import React from 'react';
import { ContainerComponent, wrap } from 'AppReact';
import { FlexCenterWrapper, FitRelativeWrapper, Mx2, Mt2 } from 'wrappers';
import Controller from './controller';
import internalState from './internalState';
import { DropdownBodyWrapper, PointerWrapper, TextWrapper } from './wrappers';
import { DownCaretSvg } from 'components/icons';
import { SecondaryTextSm, SecondaryTextSm300, Icon, PrimaryTextSm } from 'atoms';
import { Label } from './atoms';

const containerRef = React.createRef();

export const definition = {
  name: 'AdditionalInfoRowEdit',
  controller: Controller,
  initialProps: ({ value, label, icon, primary }) => ({ value, label, icon, primary }),
  props: internalState,
  elements: [
    {
      component: Icon,
      name: 'Icon',
      renderIf: ({ icon }) => !!icon && Object.keys(icon).length !== 0,
      displayValue: ({ icon }) => icon
    },
    {
      component: wrap(SecondaryTextSm300, TextWrapper),
      name: 'Label',
      renderIf: ({ primary }) => !primary,
      displayValue: ({ label }) => label
    },
    {
      component: wrap(PrimaryTextSm, TextWrapper),
      name: 'Label',
      renderIf: ({ primary }) => primary,
      displayValue: ({ label }) => label
    },
    {
      wrapper: FitRelativeWrapper,
      name: 'Dropdown',
      elements: [
        {
          wrapper: wrap(FlexCenterWrapper, PointerWrapper),
          name: 'Selector',
          isButton: true,
          bindings: ({ isOpen }) => ({ isOpen, containerRef }),
          elements: [
            {
              component: Label,
              name: 'Value',
              displayValue: ({ value }) => value ? 'Yes' : 'No'
            },
            {
              component: Icon,
              name: 'Caret',
              displayValue: ({ }) => DownCaretSvg({ color: window?.settings?.secondary_color ?? '#04333b' })
            }
          ]
        },
        {
          wrapper: DropdownBodyWrapper,
          name: 'Body',
          ref: containerRef,
          renderIf: ({ isOpen }) => isOpen,
          elements: [
            {
              wrapper: wrap(wrap(PointerWrapper, Mx2), Mt2),
              name: 'Yes',
              isButton: true,
              bindings: ({ }) => ({ value: true }),
              elements: [
                {
                  component: SecondaryTextSm,
                  name: 'Yes',
                  displayValue: ({ }) => 'Yes'
                },
              ]
            },
            {
              wrapper: wrap(wrap(PointerWrapper, Mx2), Mt2),
              name: 'No',
              isButton: true,
              bindings: ({ }) => ({ value: false }),
              elements: [
                {
                  component: SecondaryTextSm,
                  name: 'No',
                  displayValue: ({ }) => 'No'
                },
              ]
            },
          ]
        }
      ]
    }
  ]
};

export default wrap(ContainerComponent(definition), FlexCenterWrapper);
